<template>
    <div class="view view--wallpapers">
        <wallpaper-list v-bind:selectable="false"
                        v-bind:show-bulk-actions="true"
                        v-bind:show-filters="{ 'category': true }"
                        v-bind:show-actions="true"
                        v-bind:show-paging="true"
                        v-bind:show-title="false"
        />
    </div>
</template>

<script>
    import wallpaperList from '../../components/WallpaperList.vue';

    export default {
        components: {
            wallpaperList
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/wallpapers/Index.vue